/**
 * Document strip host — the DOM node in Layout's chrome that the shared
 * document tab strip (`@suite/documents` WorkspaceShell) portals into.
 *
 * The strip renders through `stripPortalTarget` so it lives in the app
 * chrome (directly under the suite top bar) instead of inside the routed
 * workbench surface: one identical, always-visible placement across every
 * view mode (BIM / 2D / 3D / Sketch), unaffected by workbench-local layout
 * or overlays. Layout owns the host element; WorkbenchSurface consumes it.
 */

import { createContext, useContext } from 'react';

export const DocStripHostContext = createContext<HTMLDivElement | null>(null);

/** The mounted strip host element, or null before Layout commits it (the
 * shell then falls back to rendering the strip inline in its group pane). */
export function useDocStripHost(): HTMLDivElement | null {
    return useContext(DocStripHostContext);
}
